(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bpc-hardware-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  document.querySelectorAll('.bpc-hardware-menu[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.bpc-hardware-menu[open]').forEach(function (menu) {
    if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    menu.open = false;
  });
});
document.addEventListener('focusin', function (event) {
  document.querySelectorAll('.bpc-hardware-menu[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
  } catch(e) { console.error(e); }
})();

})();
